


















import { editFactory } from '@/main/pages';
import { Typ } from '@/modules/ciselnik/dilenske/typ';


import { store } from './store/edit';
import { NAME } from './constants';
import { editMutations } from './store/types';

export default editFactory(NAME, store).extend({
	components: {
		TypSelect: Typ.components.Select,
	},

	computed: {
		mutationsMappers() {
			return {
				typKod: `${this.storeUri}/${editMutations.OJETE_VOZY_TYP_KOD_SELECT_MAPPER}`,
			};
		},
		typkodFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
			};
		},
	},
});
